import $device from '@/plugin/common/device' // 工具类
import Vue from 'vue'

Vue.prototype.$device = $device
